import { render } from "./AdminPackageCreate.vue?vue&type=template&id=2743079e&scoped=true&ts=true&lang=pug"
import script from "./AdminPackageCreate.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminPackageCreate.vue?vue&type=script&lang=ts&setup=true"

import "./AdminPackageCreate.vue?vue&type=style&index=0&id=2743079e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2743079e"]])

export default __exports__